<template>
    <div class="wrap fx-v-center" :class="{ 'can-hover': canHover }" :style="{ height: height }">
        <div class="left fx-v-center">
            <div class="fx-v-center left-inner">
                <i class="iconfont logo" :class="logoClass"/>
                <span class="name">{{ name }}</span>
            </div>
            <span class="des text-popper" v-textPopper v-if="des">{{ des }}</span>
            <slot name="des"/>
        </div>
        <div class="right fx-v-center">
            <button class="text-btn" @click="$emit('btn-clicked')" v-if="btnText">
                {{ btnText }}
            </button>
            <slot name="btn"/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        logoClass: String,
        name: String,
        des: String,
        btnText: String,
        canHover: {
            type: Boolean,
            default: true
        },
        height: {
            type: String,
            default: '44px'
        }
    }
}
</script>

<style lang="scss" scoped>
.fx-v-center {
    display: flex;
    align-items: center;
}

.wrap {
    height: 44px;
    justify-content: space-between;
    padding: 0 10px;
    font-size: 14px;
    letter-spacing: 0;

    &.can-hover:hover {
        background: #f7f7f7;
    }

    .left {
        flex: 1;
        min-width: 100px;
        max-width: 600px;

        .logo {
            flex: none;
            color: #999;
        }

        .name {
            display: inline-block;
            min-width: 56px;
            margin: 0 20px 0 10px;
            color: #999;
        }

        .des {
            color: #333;
        }
    }
}
</style>
